export default {
  // Navbar
  "nav.home": "Home",
  "nav.guide": "Complete Guide",
  "nav.shopGuide": "Shopping Guide",
  "nav.categories": "Categories",
  "nav.faq": "FAQ",
  "nav.language": "Language",

  // Announcement
  "announce": "Independent resource • Regularly updated • Always verify links before ordering",

  // Hero
  "hero.badge": "USFans Spreadsheet Resource Hub",
  "hero.title": "USFans Spreadsheet — Your Complete Guide to Links, Shipping & Buying",
  "hero.subtitle": "Find curated links, honest reviews, shipping details, warehouse and QC info, plus coupon and discount code guidance — all organized in one clean, easy-to-navigate place.",
  "hero.cta1": "USFans Spreadsheet",
  "hero.cta2": "Buy It Now",
  "hero.trust": "Independent source • Freshly updated • Safe link usage",

  // Dropdown
  "dropdown.label": "Browse categories",
  "dropdown.placeholder": "Select a category…",

  // Categories section
  "categories.title": "Shop by Category",
  "categories.subtitle": "Jump straight to the products you are looking for on USFans.",

  // About
  "about.title": "What is the USFans Spreadsheet?",
  "about.p1": "The USFans Spreadsheet is a clean, organized collection of product links and category shortcuts that helps you find what you are looking for faster. Instead of digging through endless pages, the spreadsheet groups items into familiar categories — shoes, hoodies, t-shirts, jackets and more — so you can jump straight to the section that matters to you.",
  "about.p2": "Our goal is simple: gather the most useful information and links in one transparent, easy-to-browse format. We cover reviews, shipping costs, warehouse details, quality checks, coupons and safety tips, so you can make a more confident decision before placing an order.",

  // Features
  "features.title": "Everything about USFans in one place",
  "features.subtitle": "Six essential topics to help you understand the service before you buy.",
  "feat.review.title": "USFans Review",
  "feat.review.desc": "Learn the key points, pros, cons and the details worth checking before you use the service.",
  "feat.shipping.title": "USFans Shipping Cost",
  "feat.shipping.desc": "Understand which factors affect shipping prices and how to compare your available options.",
  "feat.warehouse.title": "USFans Warehouse",
  "feat.warehouse.desc": "Learn the basics of storage, handling and order checks inside the warehouse.",
  "feat.legit.title": "USFans Legit",
  "feat.legit.desc": "Find out how to independently judge the trustworthiness of the site, links and sellers.",
  "feat.coupon.title": "USFans Coupon",
  "feat.coupon.desc": "Discover how to find promotions and verify that a discount code is still valid.",
  "feat.discount.title": "USFans Discount Code",
  "feat.discount.desc": "Learn how to check a code's expiry and terms before you apply it at checkout.",

  // Why
  "why.title": "Why use our guide?",
  "why.subtitle": "A clear, structured starting point for anyone new to USFans.",
  "why.1": "Organized information",
  "why.2": "Practical how-to guides",
  "why.3": "Honest comparisons",
  "why.4": "Quality check (QC) details",
  "why.5": "Shipping explanations",
  "why.6": "Safety recommendations",
  "why.7": "Regular updates",
  "why.8": "Easy navigation",

  // Article CTA
  "articleCta.title": "New to USFans? Start with our complete guide",
  "articleCta.subtitle": "A step-by-step walkthrough covering categories, shipping, QC, coupons and safety — written for beginners.",
  "articleCta.button": "Read the Complete Guide",

  // Safety
  "safety.title": "Safety first",
  "safety.text": "Always verify the website address, links, seller, prices, payment methods and shipping details before making a decision. This site is an independent information resource and does not guarantee the availability, safety or accuracy of third-party services.",
  "safety.cta": "Visit the Safety Center",

  // FAQ
  "faq.title": "Frequently Asked Questions",
  "faq.1q": "What is the USFans Spreadsheet?",
  "faq.1a": "It is an organized collection of USFans product links grouped into categories such as shoes, hoodies, t-shirts, jackets and accessories, designed to help you find products faster.",
  "faq.2q": "Is USFans legit?",
  "faq.2a": "USFans is a widely discussed service, but we always recommend verifying links, sellers, prices and payment methods yourself before ordering. No third-party service can be guaranteed safe without your own checks.",
  "faq.3q": "How much does USFans shipping cost?",
  "faq.3a": "Shipping costs depend on several factors including the destination, package weight, shipping method and any warehouse fees. It is best to compare the available options at checkout.",
  "faq.4q": "Where can I find USFans coupons or discount codes?",
  "faq.4a": "Promotions change frequently. We recommend checking the official site directly and verifying any code's expiry date and terms before applying it.",
  "faq.5q": "How do I use the USFans Spreadsheet?",
  "faq.5a": "Simply pick a category from the dropdown or the buttons above, and you will be taken straight to the relevant USFans page for that product type.",

  // CTA banner
  "ctaBanner.title": "Ready to find what you need on USFans?",
  "ctaBanner.subtitle": "Open the spreadsheet and browse a clean, organized collection of links, guides and comparisons.",
  "ctaBanner.button": "Open USFans Spreadsheet",

  // Footer
  "footer.tagline": "An independent informational resource about the USFans Spreadsheet.",
  "footer.disclaimer": "This website is an independent information resource and is not affiliated with or endorsed by USFans. Always verify URLs, sellers, prices and third-party services independently before taking action.",
  "footer.nav": "Navigation",
  "footer.resources": "Resources",
  "footer.languages": "Languages",
  "footer.rights": "All rights reserved.",
  "footer.backHome": "Back to Home",
};